'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAppIsReady, getUniversalAppIsReady } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import AppReadyComponent from 'ContentEditorUI/components/app/AppReadyComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    isReady: getAppIsReady(state),
    isUniversalAppReady: getUniversalAppIsReady(state)
  };
};
class AppReadyContainer extends Component {
  render() {
    return /*#__PURE__*/_jsx(AppReadyComponent, Object.assign({}, this.props));
  }
}
/* eslint-enable react/prop-types */
AppReadyContainer.propTypes = {
  fallbackComponent: PropTypes.node
};
AppReadyContainer.defaultProps = {
  isUniversalAppReady: false
};
export default connect(mapStateToProps)(AppReadyContainer);